import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../../apiClient'
import { USE_GET_PROGRAM_ONTOLOGY_KEY } from '../useGetCurrentProgramOntologyConfig'

type UseDeleteOntologyPredictionCorrectionParams = {
  predictionCorrectionId: string
  programId: string
}

export function useDeleteOntologyPredictionCorrection() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ predictionCorrectionId, programId }: UseDeleteOntologyPredictionCorrectionParams) =>
      await apiClient.delete(
        `/int/v3/programs/${programId}/ontology/prediction-corrections/${predictionCorrectionId}`
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USE_GET_PROGRAM_ONTOLOGY_KEY] })
    },
  })
}
